import React, { useEffect } from 'react';

export default function StickyHeader(props) {
    useEffect(() => {
        const header = document.querySelector('.xs_sectionHeader');
        if (header) {
            document.body.style = `--sticky-header-height: ${header.offsetHeight}px`;
        }
    });

    useEffect(() => {
        const handleScroll = () => {
            const elements = [
                document.getElementsByClassName('xs_prematchLinksWh')[0],
                document.getElementsByClassName('xs_dateSelectionNavbar')[0],
                document.getElementsByClassName('xs_liveMatchInfo')[0],
                document.getElementsByClassName('xs_eventSectionsButtons')[0],
                document.getElementsByClassName('xs_matchInfo')[0],
            ];

            const scroller = document.getElementById('xs-scroller-container');
            if (scroller) {
                elements.forEach(element => {
                    if (element) {
                        if (scroller.scrollTop > 0) {
                            element.classList.add('displayHiddenSticky');
                        } else {
                            element.classList.remove('displayHiddenSticky');
                        }
                    }
                });
            }
        };

        const addScrollListener = () => {
            const scroller = document.getElementById('xs-scroller-container');
            if (scroller) {
                scroller.addEventListener('scroll', handleScroll);
            }
        };

        const timeoutId = setTimeout(addScrollListener, 100);
        return () => {
            clearTimeout(timeoutId);
            const scroller = document.getElementById('xs-scroller-container');
            if (scroller) {
                scroller.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <div className={"xs_sectionHeader " + (props.className || '')}>
            {props.children}
        </div>
    );
}
